import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login/login/login.component';
import { SharedModule } from '../../shared/shared.module';



@NgModule({
  declarations: [LoginComponent],
  imports: [
    SharedModule,
    CommonModule
  ]
})
export class LoginModule { }
